import { HTMLAttributes } from 'react'
import cn from 'classnames'

import s from './ContactNumber.module.scss'

interface IMobileContactNumber extends HTMLAttributes<HTMLDivElement> {
  isMounted: boolean
}

export default function ContactNumber({
  isMounted,
  className,
}: IMobileContactNumber) {
  if (!isMounted) return null

  return (
    <a
      href="tel:+1-888-488-7203"
      onClick={() => {
        if (window && window.dataLayer) window.dataLayer.push({ event: 'call' }) // GTM call
      }}
      className={cn(s.phoneNumber, className)}
    >
      <img
        src="/header/phone-green.svg"
        className={s.phoneIcon}
        alt="green phone"
      />
      <span className={s.call}>Call</span> (888) 488-7203
    </a>
  )
}
